<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns1"
      :loading="modalLoading"
      :data="queryInstanceByGroupIdList"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="actions">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="instanceDelmodal = true"
            v-hasPermission="[
              'permissionsConfigurationManagement:resourcePermission:delete_instance'
            ]"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>

    <Modal v-model="instanceDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ Name }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="deleteInstance()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
var tableInstances = {};
export default {
  name: "TableInstances",
  props: ["getAccountType"],
  data() {
    return {
      accountType: "",
      accountName: "",
      instanceId: "",
      privateIp: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      Name: "",
      modalLoading: true,
      instanceDelmodal: false,
      isDisable: false,
      columns1: [
        {
          title: this.$t("permission_configuration_management.group.account"),
          key: "accountName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.accountType"
          ),
          key: "accountTypeName"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.instanceID"
          ),
          key: "instanceId"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.instanceName"
          ),
          key: "name",
          width: "120px"
        },
        {
          title: this.$t("permission_configuration_management.group.region"),
          key: "region"
        },
        {
          title: this.$t("permission_configuration_management.group.privateIP"),
          key: "privateIp"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "stateName"
        },
        {
          title: this.$t("common.operation"),
          slot: "actions"
        }
      ],
      queryInstanceByGroupIdList: [
        {
          name: ""
        }
      ]
    };
  },
  beforeCreate: function() {
    tableInstances = this;
  },
  methods: {
    // 点击备份目标的时候显示实例列表
    queryInstancesByGroupId: function() {
      eventBus.$on("accountName", function(val) {
        tableInstances.accountName = val;
      });
      eventBus.$on("accountType", function(val) {
        tableInstances.accountType = val;
      });
      eventBus.$on("instanceId", function(val) {
        tableInstances.instanceId = val;
      });
      eventBus.$on("privateIp", function(val) {
        tableInstances.privateIp = val;
      });
      tableInstances.$api.instance
        .selectQueryInstancesByGroupId({
          groupId: this.$route.query.id,
          pageNum: this.current,
          pageSize: this.pageSize,
          accountType: this.getAccountType,
          accountName: tableInstances.accountName,
          instanceId: tableInstances.instanceId,
          privateIp: tableInstances.privateIp
        })
        .then(res => {
          this.modalLoading = false;
          this.queryInstanceByGroupIdList = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(res => {
          // 如果列表里没数据 返回
          this.queryInstanceByGroupIdList = undefined;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableInstances.queryInstancesByGroupId();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableInstances.queryInstancesByGroupId();
    },
    // 显示所有数据
    showAllInstance: function() {
      tableInstances.queryInstancesByGroupId();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.Name = this.queryInstanceByGroupIdList[index].name;
    },
    // 删除instance
    deleteInstance: function() {
      this.isDisable = true; // 开始可以点击
      var lineIndex = this.lineIndex;
      // 删除实例
      tableInstances.$api.groupInstanceRelation
        .deleteGroupInstanceRelation({
          groupId: this.$route.query.id,
          instanceId: this.queryInstanceByGroupIdList[lineIndex].id
        })
        .then(res => {
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableInstances.queryInstancesByGroupId();
            this.isDisable = false;
            this.instanceDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/TableInstances.vue